import { render } from "./subject.vue?vue&type=template&id=64db347d"
import script from "./subject.vue?vue&type=script&lang=js"
export * from "./subject.vue?vue&type=script&lang=js"
script.render = render

export default script